export interface ThemeState {
  currentTheme: string | null;
}

export const initialState: ThemeState = {
  currentTheme: null,
};
